import React from 'react'
import { Field } from 'redux-form'

import { translate } from 'parking-react-common'

import { forms, ui } from '../redux'

import Panel from '../components/Panel'
import Button from '../components/Button'
import UserSearchBox from '../components/UserSearchBox'
import { Column, Row } from '../components/Grid'
import form from '../components/Form'

const PrivilegeForm = ({ t }) => (
    <Panel title={ t('Add a new privileged user') }>
        <Column span={ 6 }>
            <Field
                name="user"
                component={ UserSearchBox }
            />
            <br />
            <br />
            <Row>
                <Column span={ 6 }>
                    <Button
                        type="submit"
                        label={ t('Add to Privileged') }
                        size={ ui.SIZE.large }
                        intent={ ui.INTENT.primary }
                        isBlock
                    />
                </Column>
            </Row>
        </Column>
    </Panel>
)

PrivilegeForm.propTypes = forms.propTypes

export default translate()(form({ id: forms.privilege.id })(PrivilegeForm))
